import React, {useState, useEffect,useLayoutEffect} from 'react';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {format, fromUnixTime} from 'date-fns';
import {es} from 'date-fns/locale';
import { useNavigate } from "react-router-dom";
import { ReactComponent as IconoDetalle } from './../imagenes/detalle.svg';
import { ReactComponent as IconoEditar } from './../imagenes/editar.svg';
import { ReactComponent as IconoBorrar } from './../imagenes/borrar.svg';
import { ReactComponent as IconoHora } from './../imagenes/hora.svg';
import { ReactComponent as IconoCliente } from './../imagenes/cliente.svg';
import { ReactComponent as IconoEstado } from './../imagenes/estado.svg';
import useObtenerViajes from './../hooks/useObtenerViajes';
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from './../elementos/Header';
import BotonCerrarSesion from "./../elementos/BotonCerrarSesion";
import {ContenedorNavegador,
  BotonNavegador,
  BotonsRecarga,
  Icono,
  Lista,
  ElementoLista,
  Descripcion,
  Fecha,
  BotonAccion,
  Input,
  ContenedorFiltro,
  BotonFiltro,
  ContenedorSubtitulo,
  Subtitulo,
  Boton,
  ContenedorFiltroDoble,
  ContenedorFiltroMoviles,
  Lista2
} from './../elementos/ElementosApp';
import SelectPasajeros from './SelectPasajeros'
import SelectClientesFiltro from './SelectClientesFiltro';
import IconoMovilEstado from "./../elementos/IconoEstado";
import { useAuth } from './../contextos/AuthContext';
import Swal from 'sweetalert2';
import {db} from '../firebase/firebaseConfig';
import { ref, update} from "firebase/database";
import useObtenerConductores from './../hooks/useObtenerConductores';
import useObtenerClientes from "./../hooks/useObtenerClientes";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck,faPhone,faEnvelope,faUser, faToggleOn,faAddressCard,faPalette,faCar,faCarTunnel,faTrailer, faLocationCrosshairs} from '@fortawesome/free-solid-svg-icons';
import BtnRegresar from "../elementos/BtnRegresar";
import {auth} from '../firebase/firebaseConfig';
import {signOut} from 'firebase/auth';
import useObtenerAdmin from './../hooks/useObtenerAdmin';




const TrasladosActivos = () => {
  const [fechaActual, cambiarFechaActual] = useState (new Date());
  const [fechaActualp, cambiarFechaActualP] = useState (new Date());
  const [filtroMovil, cambiarFiltroMovil] = useState (0);
  const [filtroServicio, cambiarFiltroServicio] = useState ('TODOS');
  const {usuario} = useAuth();
  var movilesAsignados = [];
  var serviciosAsignados = [];
  const [movilbusqueda, cambiarMovilbusqueda] = useState([]);
  const time = toTimestamp(fechaActual)
  const viajes = useObtenerViajes(time);
  const viajesfiltroCancelado = viajes.filter(item => item.estado !== 'Cancelado')
  const viajesfiltroTerminado = viajesfiltroCancelado.filter(item => item.estado !== 'Terminado')
  const viajesordenadorfecha = viajesfiltroTerminado.sort((a, b) => (a.fecha_hora_programada > b.fecha_hora_programada ? 1 : a.fecha_hora_programada < b.fecha_hora_programada ? -1 : 0))
  const [viajeFiltro, cambiarViajeFiltro] = useState ([]);
	const navigate = useNavigate();
  //const {usuario} = useAuth();
  const [TipoUsuario, cambiarTipoUsuario] = useState([]);
  const uid = usuario.uid
  const UsarioLog = useObtenerAdmin({uid});
  const [Escliente, cambiarEscliente] = useState(true);





useEffect (()=>{    
  console.log(UsarioLog)    
  if (UsarioLog.cliente === 'undefined' || UsarioLog.cliente === 'Sin Permisos' || UsarioLog.cliente === null)
  {cambiarTipoUsuario('salir')}
  else
  {    
    if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
      {cambiarTipoUsuario('admin')}
    else
      {
        if (Number(UsarioLog.numero) > 0)
        {{cambiarTipoUsuario('conductor')}
      }
        else{
          {cambiarTipoUsuario('cliente')}
      }
        
      }
  }
},[UsarioLog]);


useEffect (()=>{    
   
    if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
      {cambiarTipoUsuario('admin')
      console.log('entra admin')
      cambiarEscliente(false)
      cambiarFiltroServicio('TODOS')
    }
    else
      {{cambiarTipoUsuario('cliente')}
      console.log('entra cliente')
      console.log(UsarioLog.cliente)
      cambiarFiltroServicio(UsarioLog.cliente)
    }
    if (Number(UsarioLog.numero) > 0)
    {cambiarTipoUsuario('conductor')
    console.log('entra conductor')
    cambiarEscliente(false)
    cambiarFiltroServicio('TODOS')
    cambiarFiltroMovil(Number(UsarioLog.numero))
  } 
  
},[UsarioLog]);

  useEffect(() => {
    if (filtroMovil === 0 && filtroServicio === 'TODOS' ) {
      cambiarViajeFiltro(viajesordenadorfecha)
    } else
    { if (filtroMovil !== 0 && filtroServicio === 'TODOS') {
      cambiarViajeFiltro(viajesordenadorfecha.filter(item => Number(item.numero_m) === Number(filtroMovil)))
      } else { 
        if  (filtroMovil === 0 && filtroServicio !== 'TODOS') {
          if  (filtroServicio === 'Grupo Mutual')
              {
              let mutuales = ['Mutual Agustinas ','Mutual De Seguridad','Mutual Enea','Mutual La Florida','Mutual Lo Espejo','Mutual Maipu','Mutual Paine','Mutual Providencia','Mutual Puente Alto','Mutual Quilicura','MUTUAL SAM615','MUTUAL SCM590','Mutual Las Condes','Mutual Las Tranqueras','Mutual Sindicato','Mutual San Bernardo','Mutual Talagante']
                cambiarViajeFiltro(viajesordenadorfecha.filter(item => mutuales.includes(item.empresa)))
              }
          else {
                cambiarViajeFiltro(viajesordenadorfecha.filter(item => item.empresa === filtroServicio))
                }
       
        
        } else {
          if  (filtroServicio === 'Grupo Mutual')
          {
          let mutuales = ['Mutual Agustinas ','Mutual De Seguridad','Mutual Enea','Mutual La Florida','Mutual Lo Espejo','Mutual Maipu','Mutual Paine','Mutual Providencia','Mutual Puente Alto','Mutual Quilicura','MUTUAL SAM615','MUTUAL SCM590','Mutual Las Condes','Mutual Las Tranqueras','Mutual Sindicato','Mutual San Bernardo','Mutual Talagante']
            
            cambiarViajeFiltro(viajesordenadorfecha.filter(item => ((item => mutuales.includes(item.empresa)) && Number(item.numero_m) === Number(filtroMovil))))

          }
      else {
        cambiarViajeFiltro(viajesordenadorfecha.filter(item => (item.empresa === filtroServicio && Number(item.numero_m) === Number(filtroMovil))))
        
            }

          
        
        
        }
    }
    }
  }, [filtroMovil,fechaActualp,filtroServicio]);


  const moviles= useObtenerConductores();
  moviles.sort((a, b) => (Number(a.numero) > Number(b.numero) ? 1 : Number(a.numero) < Number(b.numero) ? -1 : 0))
  const movilesactivos = moviles.filter(item => item.estado === 'activo')
  movilesactivos.map((movil) => {
    var recuento = viajesordenadorfecha.reduce((contador, { numero_m }) => Number(numero_m) === Number(movil.numero) ? contador += 1 : contador, 0); // 6
    if (recuento>0){movilesAsignados = [...movilesAsignados,{numero_m: movil.numero, asignaciones: recuento}]}
})

const servicios= useObtenerClientes();
servicios.sort((a, b) => (a.nombrecorto > b.nombrecorto ? 1 : a.nombrecorto < b.nombrecorto ? -1 : 0))
servicios.map((servicio) => {
  var recuento = viajesordenadorfecha.reduce((contador, { empresa }) => empresa === servicio.nombrecorto ? contador += 1 : contador, 0); // 6
  if (recuento>0){serviciosAsignados = [...serviciosAsignados,{empresa: servicio.nombrecorto, asignaciones: recuento}]}
})

  const formatearFecha = (fecha) => {
		return format(fromUnixTime(fecha), "dd 'de' MMMM 'de' yyyy", {locale: es})
	}
  const formatearHora = (fecha) => {
		return format(fromUnixTime(fecha), "HH':'mm'", {locale: es})
	}


  const formatearFechaHora = (fecha) => {
		return format(fromUnixTime(fecha), "dd 'de' MMMM 'de' yyyy HH':'mm'", {locale: es})
	}


  function toTimestamp(strDate){
    var datum = Date.parse(strDate);
    return datum;
 }

const fechaEsIgual = (viajes,index,viaje) => {
        if(index !== 0){
          const fechaActual2 = formatearFecha(viaje.fecha_hora_programada/1000);
          const fechaAnterior = formatearFecha(viajes[index-1].fecha_hora_programada/1000)
          if(fechaActual2 === fechaAnterior){
            return true;
          } else {
            return false;
          }
        }
  }

const fechaEsUrgente = (fecha_hora_programada,estado) => {
      const fechaActual3 = (toTimestamp(fechaActualp))/1000
      const fechaProgramada = fecha_hora_programada/1000;
      const minutosRestantes = (fechaProgramada-fechaActual3)/60
      if(minutosRestantes <= 120 && estado ==='Programado'){
        return true;
      } else {
        return false;
      }
    
}

useEffect(() => {
  const timer = setTimeout(() => {
    cambiarFechaActualP(new Date()); 
  }, 60000);
  console.log("actualiza fecha")
  return () => clearTimeout(timer);
}, [fechaActualp]);


const onClickFiltroMovil = (e) => {
cambiarFiltroMovil(e.target.value)
}

const onClickFiltroMovilT = (e) => {
cambiarFiltroMovil(0)
}


// Comienza Asigna Viaje
const onClickAsignar = async (e) => {
const input = document.getElementById('input'+e.target.value);
const icono = document.getElementById('icon'+e.target.value);
const div = document.getElementById('div'+e.target.value);
const validaActivo = movilesactivos.findIndex(el => Number(el.numero) === Number(input.value) )
if (input.value === ''){
  await Swal.fire({
    title: 'Complete Información',
    text: 'Ingrese numero de movil a asignar',
    icon: 'error',
    timer:2000
    })
return;
}
if (validaActivo === -1){
  await Swal.fire({
    title: 'Error de Datos',
    text: 'El numero Ingresado no es Movil activo',
    icon: 'error',
    timer:2000
    })
}else{
  var salir = false

//valida que no tenga viajes activos
const viajebusca = viajesordenadorfecha.filter(item => item.id === e.target.value )
const viajes15 = viajesordenadorfecha.filter(item => Number(item.fecha_hora_programada) >= (Number((viajebusca[0].fecha_hora_programada/1000)-900)) && Number(item.fecha_hora_programada) <= (Number((viajebusca[0].fecha_hora_programada/1000)-900)))
var viajes15filtro = viajes15.filter(item => item.estado !== 'Terminado')
viajes15filtro = viajes15filtro.filter(item => item.estado !== 'Cancelado')
viajes15filtro = viajes15filtro.filter(item => item.id !== e.target.value)
const MovilViajes = viajes15filtro.filter(item => Number(item.numero_m) === Number(input.value))
if(MovilViajes.length>0){
    Swal.fire({
        title: 'Movil Ya asignado',
        text: 'El numero de Movil ya tiene un traslado en un rango de 15 minutos',
        icon: 'error',
        timer:4000
        })
    return;
} 
// termina validacion de 
await Swal.fire({
      title: 'Asignar Movil',
      text: '¿Desea Asignar el movil '+input.value+' al traslado?',
      icon: 'warning',
      showDenyButton: true,
      denyButtonText: 'No',
      confirmButtonText: 'Si',
      confirmButtonColor: "blue"
      }).then(response => {
          if(response.isDenied)
          {salir = true
          }
      } 
      )
  if(salir===true){return;}
  else{
    input.disabled = true
    input.style.setProperty('border','none');
    input.style.setProperty('background-color','white');
    div.hidden=true
    icono.style.setProperty('fill','blue');
    const indiceElemento = viajesordenadorfecha.findIndex(el => el.id === e.target.value )
    viajesordenadorfecha[indiceElemento] = {...viajesordenadorfecha[indiceElemento], 
      estado: 'Asignado', 
      color_m:  movilesactivos[validaActivo].color,
      nombre_m: movilesactivos[validaActivo].nombre,
      numero_m:  movilesactivos[validaActivo].numero,
      patente_m:  movilesactivos[validaActivo].patente,
      telefono_m:  movilesactivos[validaActivo].telefono,
      tipo_m:  movilesactivos[validaActivo].tipo
    }
    update(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/${e.target.value}`),
    {   estado: 'Asignado',
    color_m:  movilesactivos[validaActivo].color,
    nombre_m: movilesactivos[validaActivo].nombre,
    numero_m:  movilesactivos[validaActivo].numero,
    patente_m:  movilesactivos[validaActivo].patente,
    telefono_m:  movilesactivos[validaActivo].telefono,
    tipo_m:  movilesactivos[validaActivo].tipo,
        modificador : usuario.uid
    }) 
   }
}
}
// Termina Asigna viaje


// Comienza PreAsigna Viaje
const onClickPreAsignar = async (e) => {
  const input = document.getElementById('input'+e.target.value);
  const icono = document.getElementById('icon'+e.target.value);
  const div = document.getElementById('div'+e.target.value);
  const validaActivo = movilesactivos.findIndex(el => Number(el.numero) === Number(input.value) )
  if (input.value === ''){
    await Swal.fire({
      title: 'Complete Información',
      text: 'Ingrese numero de movil a asignar',
      icon: 'error',
      timer:2000
      })
  return;
  }
  if (validaActivo === -1){
    await Swal.fire({
      title: 'Error de Datos',
      text: 'El numero Ingresado no es Movil activo',
      icon: 'error',
      timer:2000
      })
  }else{
    var salir = false
  
  //valida que no tenga viajes activos
  const viajebusca = viajesordenadorfecha.filter(item => item.id === e.target.value )
  const viajes15 = viajesordenadorfecha.filter(item => Number(item.fecha_hora_programada) >= (Number((viajebusca[0].fecha_hora_programada/1000)-900)) && Number(item.fecha_hora_programada) <= (Number((viajebusca[0].fecha_hora_programada/1000)-900)))
  var viajes15filtro = viajes15.filter(item => item.estado !== 'Terminado')
  viajes15filtro = viajes15filtro.filter(item => item.estado !== 'Cancelado')
  viajes15filtro = viajes15filtro.filter(item => item.id !== e.target.value)
  const MovilViajes = viajes15filtro.filter(item => Number(item.numero_m) === Number(input.value))
  if(MovilViajes.length>0){
      Swal.fire({
          title: 'Movil Ya asignado',
          text: 'El numero de Movil ya tiene un traslado en un rango de 15 minutos 2',
          icon: 'error',
          timer:4000
          })
      return;
  } 
  // termina validacion de 
  await Swal.fire({
        title: 'PreAsignar Movil',
        text: '¿Desea Preasignar el movil '+input.value+' al traslado?',
        icon: 'warning',
        showDenyButton: true,
        denyButtonText: 'No',
        confirmButtonText: 'Si',
        confirmButtonColor: "blue"
        }).then(response => {
            if(response.isDenied)
            {salir = true
            }
        } 
        )
    if(salir===true){return;}
    else{
      input.disabled = false
      const indiceElemento = viajes.findIndex(el => el.id === e.target.value )
      viajes[indiceElemento] = {...viajes[indiceElemento], 
        estado: 'Preasignado', 
        numero_m:  movilesactivos[validaActivo].numero
      }
      update(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/${e.target.value}`),
      {   estado: 'Preasignado',
      numero_m:  movilesactivos[validaActivo].numero,
      modificador : usuario.uid
      }) 
     }
  }
  }
  // Termina PreAsigna viaje



// Comienza Des-PreAsigna Viaje
const onClickDesPreAsignar = async (e) => {
  const input = document.getElementById('input'+e.target.value);
  const icono = document.getElementById('icon'+e.target.value);
  const div = document.getElementById('div'+e.target.value);
  const validaActivo = movilesactivos.findIndex(el => Number(el.numero) === Number(input.value) )
  var salir = false
  await Swal.fire({
        title: 'Anular PreAsignacion',
        text: '¿Desea Quitar el movil '+input.value+' del traslado?',
        icon: 'warning',
        showDenyButton: true,
        denyButtonText: 'No',
        confirmButtonText: 'Si',
        confirmButtonColor: "blue"
        }).then(response => {
            if(response.isDenied)
            {salir = true
            }
        } 
        )
    if(salir===true){return;}
    else{
      input.value='';
      const indiceElemento = viajes.findIndex(el => el.id === e.target.value )
      viajes[indiceElemento] = {...viajes[indiceElemento], 
        estado: 'Programado', 
        numero_m:  null
      }

      update(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/${e.target.value}`),
      {   estado: 'Programado',
      numero_m:  null,
      modificador : usuario.uid
      }) 
     }
  
  }
  // Termina Des-PreAsigna viaje




















// Comienza Desactiva viaje
const onClickDesactivar = async (e) => {
  const div = document.getElementById('div'+e.target.value);
  const icono = document.getElementById('icon'+e.target.value);
    var salir = false
    await Swal.fire({
        title: 'Desactivar Traslado',
        text: '¿Desea cambiar el estado a Asignado?',
        icon: 'warning',
        showDenyButton: true,
        denyButtonText: 'No',
        confirmButtonText: 'Si',
        confirmButtonColor: "blue"
        }).then(response => {
            if(response.isDenied)
            {salir = true
            }
        } 
        )
    if(salir===true){return;}
    else{
      icono.style.setProperty('fill','blue');
      div.hidden=true
      const indiceElemento = viajesordenadorfecha.findIndex(el => el.id === e.target.value )
      viajesordenadorfecha[indiceElemento] = {...viajesordenadorfecha[indiceElemento], 
        estado: 'Asignado'
      }
      //console.log(e.target.value)
     update(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/${e.target.value}`),
      {estado: 'Asignado',
          modificador : usuario.uid
      }) 
     }
  }
  //Fin desactivar Viaje


// Termina Viaje
const onClickTerminaViaje = async (e) => {
  e.preventDefault();
  var salir = false
       await Swal.fire({
           title: 'Terminar Traslado',
           text: '¿Desea Termianr el viaje como traslado exitoso?',
           icon: 'warning',
           showDenyButton: true,
           denyButtonText: 'No',
           confirmButtonText: 'Si',
           confirmButtonColor: "blue"
           }).then(response => {
               if(response.isDenied)
               {salir = true
               }
           } 
           )
       if(salir===true){return;}
       else{
        //console.log(e.target.value)
            if (e.target.value !== '' || e.target.value !== 'undefined'){
               update(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/${e.target.value}`),
                  {estado: 'Terminado',
                      modificador : usuario.uid
                  })  
                  const li = document.getElementById('li'+e.target.value);
                  li.hidden=true
                  const filtredData = viajesordenadorfecha.filter(item => item.id !== e.target.value);

                  
          }


        }
  
        
        }    
// Fin Termina Viaje


// Cancela Viaje
const onClickCancelaViaje = async (e) => {
  e.preventDefault();
 var viaje_var =  viajesordenadorfecha.filter(item => item.id === e.target.value )
 
 
 if(viaje_var[0].estado==='Activo'){
  Swal.fire({
      title: 'Traslado Activo',
      text: 'No se puede cancelar un traslado activo, por favor contacta a Centrasl RTE para realizar la accion',
      icon: 'error',
      timer:4000
      })
  return;
} 

if (Escliente)
{  if(viaje_var[0].estado==='Programado' || viaje_var[0].estado==='Asignado'){
    const fechaActual3 = (toTimestamp(fechaActualp))/1000
    const fechaProgramada = viaje_var[0].fecha_hora_programada/1000;
    const minutosRestantes = (fechaProgramada-fechaActual3)/60
    if(minutosRestantes <= 60)
    {
      const { value: Motivo_C } = await Swal.fire({
        title: "¿Desea Cancelar Traslado?  Este tendra un costo de        $3.500",
        text: 'Debes indicar el motivo de cancelación del traslado de las : ' + formatearHora((viaje_var[0].fecha_hora_programada)/1000),
        icon: 'warning',
        input: "textarea",
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: 'Si',
        confirmButtonColor: "blue",
        inputValidator: (value) => {
          if (!value) {
            return "Debes escribir motivo de cancelacion";
          }
        }
      });
      if (Motivo_C) {
        console.log('Cancela traslado')
        console.log(Motivo_C)
        console.log(e.target.value)
        console.log(viaje_var[0].estado)
        if (e.target.value !== '' || e.target.value !== 'undefined'){
          update(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/${e.target.value}`),
             {estado: 'Cancelado',
              modificador : usuario.uid,
              comentarios: viaje_var[0].comentarios+'// Motivo de Cancelacion //'+ Motivo_C,
              tarifa_fija_c : Number(3500)
             })  
             const li = document.getElementById('li'+e.target.value);
             li.hidden=true
             const filtredData = viajesordenadorfecha.filter(item => item.id !== e.target.value);
     }
        Swal.fire(`Traslado Cancelado`);
      }
    }
    else
    { 
      const { value: Motivo_C } = await Swal.fire({
        title: "¿Desea Cancelar Traslado?",
        text: 'Debes indicar el motivo de cancelación del traslado de las : ' + formatearHora((viaje_var[0].fecha_hora_programada)/1000),
        icon: 'warning',
        input: "textarea",
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: 'Si',
        confirmButtonColor: "blue",
        inputValidator: (value) => {
          if (!value) {
            return "Debes escribir motivo de cancelacion";
          }
        }
      });
      if (Motivo_C) {
        console.log('Cancela traslado')
        console.log(Motivo_C)
        console.log(e.target.value)
        console.log(viaje_var[0].estado)
        if (e.target.value !== '' || e.target.value !== 'undefined'){
          update(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/${e.target.value}`),
             {estado: 'Cancelado',
              comentarios: viaje_var[0].comentarios+'// Motivo de Cancelacion //'+ Motivo_C,
              modificador : usuario.uid
             })  
             const li = document.getElementById('li'+e.target.value);
             li.hidden=true
             const filtredData = viajesordenadorfecha.filter(item => item.id !== e.target.value);
     }

        Swal.fire(`Traslado Cancelado`);
      }
    }

  } 
} 
else 
{
  console.log('entra a NO es clenrte')
  const { value: Motivo_C } = await Swal.fire({
    title: "¿Desea Cancelar Traslado?",
    text: 'Debes indicar el motivo de cancelación del traslado de las : ' + formatearHora((viaje_var[0].fecha_hora_programada)/1000),
    icon: 'warning',
    input: "textarea",
    showCancelButton: true,
    cancelButtonText: 'No',
    confirmButtonText: 'Si',
    confirmButtonColor: "blue",
    inputValidator: (value) => {
      if (!value) {
        return "Debes escribir motivo de cancelacion";
      }
    }
  });
  if (Motivo_C) {
    console.log('Cancela traslado')
    console.log(Motivo_C)
    console.log(e.target.value)
    console.log(viaje_var[0].estado)
    if (e.target.value !== '' || e.target.value !== 'undefined'){
      update(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/${e.target.value}`),
         {estado: 'Cancelado',
          modificador : usuario.uid,
          comentarios: viaje_var[0].comentarios+'// Motivo de Cancelacion //'+ Motivo_C
         })  
         const li = document.getElementById('li'+e.target.value);
         li.hidden=true
         const filtredData = viajesordenadorfecha.filter(item => item.id !== e.target.value);
 }
    Swal.fire(`Traslado Cancelado`);
  }
}
} 
// Fin Cancela Viaje

// Edita Viaje
const onClickEditaViaje = async (e) => {
  e.preventDefault();
  var viaje_var =  viajesordenadorfecha.filter(item => item.id === e.target.value )
  if(Escliente){
    console.log('Entra a Es cliente antes de viaje')
    console.log(viaje_var[0])
    console.log(viaje_var[0].estado)
    const fechaActual3 = (toTimestamp(fechaActualp))/1000
    const fechaProgramada = viaje_var[0].fecha_hora_programada/1000;
    const minutosRestantes = (fechaProgramada-fechaActual3)/60
    var date = new Date()
    var numberOfMlSeconds = date.getTime();
    var addMlSeconds4 = 60 * 60000 * 4; // 4 horas de programacion
    var addMlSeconds1 = 60 * 60000; // 4 horas de programacion
    var cuatrohoras = new Date(numberOfMlSeconds + addMlSeconds4);
    var unahora = new Date(numberOfMlSeconds + addMlSeconds1);
    var hora = format(date, "HH'", {locale: es})
    var salir = false
    if (viaje_var[0].estado === 'Activo' || viaje_var[0].estado === 'Asignado')
        {
           await Swal.fire({
                title: 'Solo se puede editar un traslado sin asignar',
                text: 'Favor considerar comunicarse vía telefónica +56 222225132 / 222221126 / 222223125 Móvil 961594201 o correo a central@radiotaxiestrella.cl.',
                icon: 'error',
                timer:20000
                })
            {salir = true};
        } 
        else 
        {
            if(hora === ("08" || "09" || "10" || "11" || "12" || "13" || "14" || "15" || "16" || "17" || "18" || "19")){
                if(viaje_var[0].fecha_hora_programada <= (new Date(unahora))){
                  await    Swal.fire({
                        title: 'Solo se puede editar un traslado con al menos una hora de anticipación',
                        text: 'Favor considerar comunicarse vía telefónica +56 222225132 / 222221126 / 222223125 Móvil 961594201 o correo a central@radiotaxiestrella.cl.',
                        icon: 'error',
                        timer:20000
                        })
                    {salir = true};
                    }
            }else{
                if(viaje_var[0].fecha_hora_programada <= (new Date(cuatrohoras))){
                  await Swal.fire({
                        title: 'Solo se puede editar un traslado con al menos cuatro horas de anticipación',
                        text: 'Favor considerar comunicarse vía telefónica +56 222225132 / 222221126 / 222223125 Móvil 961594201 o correo a central@radiotaxiestrella.cl.',
                        icon: 'error',
                        timer:20000
                        })
                    {salir = true};
                    }                
            }
        }
        if (salir === false)
        {
            navigate(`/editar-viaje/${viaje_var[0].id}`);
        }  
          
    }
} 
// Fin Edita Viaje

console.log(viajeFiltro)


return (
    <>
      
      <Helmet>
        <title> Traslados Programados  </title>
        
      </Helmet>
      <Header>
      
      <ContenedorNavegador>
      <BtnRegresar></BtnRegresar>
      
      <BotonNavegador to="/listar-terminados">Buscar</BotonNavegador>
      <BotonNavegador to="/crear-viaje">Crear</BotonNavegador>
      </ContenedorNavegador>
      <Titulo>Traslados en Curso</Titulo>         
      
      
      
      </Header>

        
        <div  hidden={Escliente}>
        <ContenedorFiltroMoviles>

        <div  hidden={(UsarioLog.hasOwnProperty("numero"))}> 
        <ContenedorFiltro>
        
        <BotonFiltro id ={'todos'} value={0} onClick={onClickFiltroMovilT}><b>Todos</b></BotonFiltro>
        
        { movilesAsignados.map((movil,index) => {
          
               return(
                  <BotonFiltro key={index} value={movil.numero_m} onClick={onClickFiltroMovil}>M:{movil.numero_m} &nbsp;#{movil.asignaciones}</BotonFiltro>
                )
              })}
          
        </ContenedorFiltro>
        </div>
        <div  hidden={!(UsarioLog.hasOwnProperty("numero"))}> 
        <ContenedorFiltro>
        <BotonFiltro id ={UsarioLog.numero} value={UsarioLog.numero} ><b>Movil {UsarioLog.numero}</b></BotonFiltro>
        </ContenedorFiltro>
        </div>
        <SelectClientesFiltro filtroServicio={filtroServicio} cambiarFiltroServicio={cambiarFiltroServicio} servicios={serviciosAsignados}/>
        </ContenedorFiltroMoviles>
        </div>       



        <Lista2>
          {viajeFiltro.map((viaje,index) => {
               return(
          <div key={viaje.id} >
                {!fechaEsIgual(viajeFiltro,index,viaje) && <Fecha>{formatearFecha((viaje.fecha_hora_programada)/1000)}</Fecha>}
                <div id ={'li'+viaje.id}>
                 <ElementoLista key={viaje.id}>
                    <ContenedorBotones>
                      <BotonAccion as={Link} to={`/detalle-viaje/${viaje.id}`}><IconoDetalle/></BotonAccion>
                      {Escliente
                    ? <BotonAccion name="edita_viaje" value={viaje.id} onClick={onClickEditaViaje}> E </BotonAccion>
                    : <BotonAccion as={Link} to={`/editar-viaje/${viaje.id}`}><IconoEditar/></BotonAccion>
                    }
                      <BotonAccion name="cancalea_viaje" value={viaje.id} onClick={onClickCancelaViaje}> X </BotonAccion>
                      <div  hidden={Escliente}><BotonAccion name="termina_viaje" value={viaje.id} onClick={onClickTerminaViaje}> T </BotonAccion></div>
                    </ContenedorBotones>
                    {!fechaEsUrgente(viaje.fecha_hora_programada,viaje.estado) 
                    ? <Descripcion  ><IconoHora/>&nbsp;{formatearHora((viaje.fecha_hora_programada)/1000)} </Descripcion>
                    : <Descripcion  style={{backgroundColor: "red"}}><IconoHora/>&nbsp;{formatearHora((viaje.fecha_hora_programada)/1000)} </Descripcion>
                    }
                    {!(viaje.estado === 'Asignado' || viaje.estado === 'ASIGNADO' || viaje.estado === 'Activo' || viaje.estado === 'ACTIVO' || viaje.estado === 'Preasignado' || viaje.estado === 'PREASIGNADO')
                    // Programado
                    ? <Descripcion><IconoMovilEstado idl ={viaje.id} estado={viaje.estado}/><div hidden={Escliente}><Input id ={'input'+viaje.id} value={viaje.numero_m} ></Input></div>
                    <div hidden={Escliente} id ={'div'+viaje.id}><BotonAccion name="asigna_viaje" value={viaje.id} onClick={onClickAsignar}>A</BotonAccion><BotonAccion name="pre_asigna_viaje" value={viaje.id} onClick={onClickPreAsignar}>P</BotonAccion></div>
                    &nbsp;&nbsp;</Descripcion>
                    :!(viaje.estado === 'Asignado' || viaje.estado === 'ASIGNADO' || viaje.estado === 'Preasignado' || viaje.estado === 'PREASIGNADO')
                    // Activo
                    ? <Descripcion><IconoMovilEstado idl ={viaje.id} estado={viaje.estado}/>&nbsp;{viaje.numero_m}<div hidden={Escliente} id ={'div'+viaje.id}><BotonAccion name="desactiva_viaje" value={viaje.id} onClick={onClickDesactivar}>I</BotonAccion></div> &nbsp;&nbsp;</Descripcion>
                    : !(viaje.estado === 'Asignado' || viaje.estado === 'ASIGNADO')
                    // Pre Asignado
                    ? <Descripcion><IconoMovilEstado idl ={viaje.id} estado={viaje.estado}/><div hidden={Escliente}><Input id ={'input'+viaje.id} value={viaje.numero_m} ></Input></div>
                    <div hidden={Escliente} id ={'div'+viaje.id}><BotonAccion name="asigna_viaje" value={viaje.id} onClick={onClickAsignar}>A</BotonAccion><BotonAccion name="Des_pre_asigna_viaje" value={viaje.id} onClick={onClickDesPreAsignar}>B</BotonAccion></div>
                    &nbsp;&nbsp;</Descripcion>
                    // Asignado
                    : <Descripcion><IconoMovilEstado estado={viaje.estado}/>&nbsp;{viaje.numero_m}&nbsp;&nbsp;</Descripcion>
                    }
                    {!(Escliente) 
                      ? <div><IconoCliente/>&nbsp;{viaje.empresa} {!(viaje.empresa ==='METRO' || viaje.empresa ==='Metro')  ? <div></div> : <div> &nbsp;&nbsp;Folio : &nbsp;{viaje.folio}</div>}</div>
                      : <div>&nbsp;{viaje.estado} {!(viaje.empresa ==='METRO' || viaje.empresa ==='Metro')  ? <div></div> : <div> &nbsp;&nbsp;Folio : &nbsp;{viaje.folio}</div>}</div>
                    }
                    {!(viaje.hasOwnProperty("pasajeros"))//(viaje.pasajeros === null || viaje.pasajeros === 'undefined') 
                    ? <></>
                    : <SelectPasajeros pasajeros = {viaje.pasajeros}/>
                    }
                </ElementoLista>
                </div>
                </div>)
          })}
            {viajeFiltro.length === 0 && 
					<ContenedorSubtitulo>
						<Subtitulo>Cargando Logica de Traslados</Subtitulo>
						
					</ContenedorSubtitulo>
				}

            </Lista2>   

    </>
  );
}
 
export default TrasladosActivos;
